__turbopack_context__.v({
  "baseClass": "vyYU7a_baseClass",
  "button": "vyYU7a_button",
  "listingCard": "vyYU7a_listingCard",
  "slide": "vyYU7a_slide",
  "wrapper": "vyYU7a_wrapper",
});
